// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2111":"76fd9591","5081":"ceafaf56","8046":"76fd9591"}[chunkId] + ".chunk.css";
};